module.exports = __webpack_public_path__ + "fbed2a4055d1a4c50986db4088765777.woff";


//////////////////
// WEBPACK FOOTER
// ./theme/bananar/assets/AmplifyTheArts/Lifeisgoofy.woff
// module id = 184
// module chunks = 0 1